import { render } from "./LiveDraws.vue?vue&type=template&id=68782c70"
import script from "./LiveDraws.vue?vue&type=script&lang=js"
export * from "./LiveDraws.vue?vue&type=script&lang=js"
script.render = render

export default script